import AdultSymptomExercisePage from "@/components/AdultSymptomExercisePage";
import { useLocaleStore } from "@/lib/stores/localeStore";
import { createFileRoute } from "@tanstack/react-router";
import ExerciseImage from "@/assets/exercise-background-photos/depression.png";
import depressionMp4 from "@/assets/videos/adults-symptoms/depression/depression.mp4";
import depressionWebm from "@/assets/videos/adults-symptoms/depression/depression.webm";
import depressionAr from "/subs/depression.ar.vtt";
import depressionEn from "/subs/depression.en.vtt";
import { isAdultExerciseGroup } from "@/lib/data/contentCatalog";

export const Route = createFileRoute("/(content)/adults/exercises/depression/")(
  {
    component: RouteComponent,
    validateSearch: (search: Record<string, unknown>) => ({
      group: isAdultExerciseGroup(search.group) ? search.group : undefined,
      mode:
        search.mode === "videos" || search.mode === "exercises"
          ? (search.mode as "videos" | "exercises")
          : undefined,
    }),
    head: () => ({
      meta: [{ title: "Depression - HAMD" }],
    }),
    beforeLoad: () => ({
      title: "exercises.categories.depression",
      navbar: {
        transparent: true,
        showTitle: false,
      },
    }),
  },
);

function RouteComponent() {
  const { group, mode } = Route.useSearch();
  const navigate = Route.useNavigate();
  const locale = useLocaleStore((state) => state.locale);
  const captionsDir: "ltr" | "rtl" = locale === "ar" ? "rtl" : "ltr";

  const videos = [
    {
      sources: [
        { src: depressionWebm, type: "video/webm" },
        { src: depressionMp4, type: "video/mp4" },
      ],
      videoClassName: "w-full h-full object-contain bg-black/40",

      subtitleTracks: [
        {
          src: depressionAr,
          srcLang: "ar",
          label: "Arabic",
          default: true,
        },
        { src: depressionEn, srcLang: "en", label: "English" },
      ],
      activeSubtitleLanguage: locale === "ar" ? "ar" : "en",
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
  ];

  return (
    <AdultSymptomExercisePage
      symptom="depression"
      titleKey="exercises.categories.depression"
      heroImage={ExerciseImage}
      videos={videos}
      mode={mode}
      onModeChange={(nextMode) =>
        navigate({
          to: Route.to,
          search: {
            mode: nextMode ?? undefined,
            group: nextMode === "exercises" ? group : undefined,
          },
        })
      }
      selectedGroup={group}
      onSelectGroup={(nextGroup) =>
        navigate({
          to: Route.to,
          search: { mode: "exercises", group: nextGroup },
        })
      }
    />
  );
}
